import axios from 'axios'
/** 
 * Axios wrapper for making API requests. 
 * It is primarily used by the store, but can be used generically in other components.
 * @param {string} jwt most API requests will require it
 * @param {object} fetchOptions
 * @param {string} fetchOptions.method GET, POST, PUT, DELETE
 * @param {string} fetchOptions.url
 * @param {object} fetchOptions.parms query parameter key/values
 * @param {object} fetchOptions.body the body (typically a JSON object)
 */
 let callApi = async function(jwt, fetchOptions){
  let {method, url, parms, body} = fetchOptions;
  method = method.toLowerCase();

  url = process.env.VUE_APP_API_BASE_URL + url;

  // if (parms) {
  //   let searchParams = new URLSearchParams();
  //   for (let key in parms) {
  //     searchParams.append(key, parms[key]);
  //   }
  //   let search = searchParams.toString();
  //   if (search) url += "?" + search;
  // }
  
  try {
    let options = {
      method,
      url,
      params: parms,
      headers: {
        "Content-Type": "application/json"
      },
    };
    if (jwt) {
      options.headers["Authorization"]=`Bearer ${jwt}`;
    }
    if (method === "post" || method === "put") {
      if (body) {
        options.data = body;
      }
    }
    let response = await axios(options);
    let content = null;
    let jsoncontent = null;
    let contentType = response.headers['Content-Type'];
    if(contentType && contentType.includes('/json')){
      jsoncontent = response.data;
    } else {
      content = response.data;
    }
    
    return jsoncontent || content;
  } catch (err) {
    // console.error('error handling in api: %o \n  %s', err.name, err.message);
    if (!err.response) {
      // No network connection.
      console.error("No network connection.");
      throw new ApiNotAvailableError("Unable to reach server. Please check your network connection.");
    } else if ([401, 403].includes(err.response.status)){
      let msg = err.response.data && err.response.data.message 
        ? err.response.data.message  
        : "Unauthorized."; 
      throw new ApiAuthorizationError(msg, err.response.status);
    } else if (400 <= err.response.status < 500) {
      throw new ApiError("Error.", err.response.status, err.response.data);
    } else if (err.response.status >= 500) {
      throw new ApiError("Server error.", err.response.status, err.response.data);
    } else {
      // Unknown error.
      console.error(err);
      console.error(`${method} ${url} error. ${err.message}`);
      throw new ApiError(`${method} ${url} error. ${err.message}`);
    } 
    
  }
}
export {callApi};


export class ApiError extends Error {
  constructor(msg, status, data){
    super(msg);
    this.status = status;
    this.data = data;
  }
}

export class ApiAuthorizationError extends ApiError {}
export class ApiNotAvailableError extends ApiError {}